// actions
const SET_SERVER_ADDRESS = 'server/SET_SERVER_ADDRESS';
const SET_SERVER_STATUS = 'server/SET_SERVER_STATUS';
const SET_MODAL_OPEN = 'server/SET_MODAL_OPEN';
const RESET_SERVER = 'server/RESET_SERVER';

const STORAGE_KEY_SERVER_ADDRESS = 'serverAddress';

interface ServerStatusState {
  serverAddress: string;
  serverStatus: boolean;
  modalOpen: boolean;
  modalWithTimer: boolean;
}

const savedAddress = localStorage.getItem(STORAGE_KEY_SERVER_ADDRESS) || '';

const DEFAULT_STATE: ServerStatusState = {
  serverAddress: savedAddress,
  serverStatus: !!savedAddress,
  modalOpen: false,
  modalWithTimer: false,
};

// reducer
const reducer = (state = DEFAULT_STATE, action): ServerStatusState => {
  switch (action.type) {
    case SET_SERVER_ADDRESS:
      localStorage.setItem(STORAGE_KEY_SERVER_ADDRESS, action.address);
      return { ...state, serverAddress: action.address };
    case SET_SERVER_STATUS:
      return { ...state, serverStatus: action.status };
    case SET_MODAL_OPEN:
      return { ...state, modalOpen: action.status, modalWithTimer: action.withTimer };
    case RESET_SERVER:
      localStorage.removeItem(STORAGE_KEY_SERVER_ADDRESS);
      return {
        ...state,
        serverAddress: '',
        serverStatus: false,
        modalOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setServerAddress = (address: string): any => ({
  type: SET_SERVER_ADDRESS,
  address,
});

export const setServerStatus = (status: boolean): any => ({
  type: SET_SERVER_STATUS,
  status,
});
export const setModalOpen = (status: boolean, withTimer: boolean = false): any => ({
  type: SET_MODAL_OPEN,
  status,
  withTimer,
});

export const resetServerState = (): any => ({ type: RESET_SERVER });
